"use strict";

exports.__esModule = true;
exports.default = void 0;

var getYearIndex = function getYearIndex(years, selectedYear) {
  return years.findIndex(function (year) {
    return year.indexOf(selectedYear) !== -1;
  });
};

var _default = getYearIndex;
exports.default = _default;